import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";

export const calculateSumOfEachRowSadan = (tableArray = []) => {


  const tableData = [...tableArray];
  tableData.forEach((singleRow, index) => {

    let {
      price,
      discount,
      weight,
      type,
      number,
      netPackWeight,
      returnedWeight,
      netReturnedWeight,
      packWeight
    } = singleRow;
    if (price === undefined) price = 0
    if (discount === undefined) discount = 0
    if (weight === undefined) weight = 0
    if (number === undefined) number = 0
    if (netPackWeight === undefined) netPackWeight = 0 // وزن خالص بسته بندی
    if (returnedWeight === undefined) returnedWeight = 0 // وزن برگشتی فله
    if (netReturnedWeight === undefined) netReturnedWeight = 0
    // وزن  برگشتی - در صورتی که بسته بندی باشه باید وزن محتویات بسته باشه
    if (packWeight === undefined) packWeight = 0

    singleRow.total = parseInt((parseInt(parseToEnRemoveComma(price)) - parseInt(parseToEnRemoveComma(discount))) * parseFloat(weight))

    // if (type === 'bulk') {
    //   singleRow.total = parseInt((parseInt(parseToEnRemoveComma(price)) - parseInt(parseToEnRemoveComma(discount))) * parseFloat(weight))
    // } else { // type = pack
    //   singleRow.total = parseInt((parseInt(parseToEnRemoveComma(price)) - parseInt(parseToEnRemoveComma(discount))) * parseFloat(number))
    // }


    singleRow.total = formatToPersianAddComma(singleRow.total)
  })
  return tableData
}
export const calculateSumOfEachRowSadanJustSaleReturn = (tableArray = []) => {


  const tableData = [...tableArray];
  tableData.forEach((singleRow, index) => {


    let {price, discount, weight, type, number,netPackWeight ,returnedWeight,netReturnedWeight,packWeight} = singleRow;
    if (price === undefined) price = 0
    if (discount === undefined) discount = 0
    if (weight === undefined) weight = 0
    if (number === undefined) number = 0
    if (netPackWeight === undefined) netPackWeight = 0 // وزن خالص بسته بندی
    if (returnedWeight === undefined) returnedWeight = 0 // وزن برگشتی فله
    if (netReturnedWeight === undefined) netReturnedWeight = 0
    // وزن  برگشتی - در صورتی که بسته بندی باشه باید وزن محتویات بسته باشه
    if (packWeight === undefined) packWeight = 0

    singleRow.total = parseInt((parseInt(parseToEnRemoveComma(price)) - parseInt(parseToEnRemoveComma(discount))) * parseFloat(returnedWeight))


    singleRow.total = formatToPersianAddComma(singleRow.total)
  })
  return tableData
}
export const calculateSumOfEachRowSadanJustSellFactor = (tableArray = []) => {


  const tableData = [...tableArray];
  tableData.forEach((singleRow, index) => {


    let {
      price,
      discount,
      weight,
      type,
      number,
      netPackWeight,
      returnedWeight,
      netReturnedWeight,
      packWeight,
    } = singleRow;
    if (price === undefined) price = 0
    if (discount === undefined) discount = 0
    if (weight === undefined) weight = 0
    if (number === undefined) number = 0
    if (netPackWeight === undefined) netPackWeight = 0 // وزن خالص بسته بندی
    if (returnedWeight === undefined) returnedWeight = 0 // وزن برگشتی فله
    if (netReturnedWeight === undefined) netReturnedWeight = 0
    // وزن  برگشتی - در صورتی که بسته بندی باشه باید وزن محتویات بسته باشه
    if (packWeight === undefined) packWeight = 0
    if (type === 'bulk') {
      singleRow.total = parseInt((parseInt(parseToEnRemoveComma(price)) - parseInt(parseToEnRemoveComma(discount))) * parseFloat(weight))
    }


    singleRow.total = formatToPersianAddComma(singleRow.total)
  })
  return tableData
}

export const deleteRowHandlerSadan = (tableArray, productId, storeId, type) => {
  const table = [...tableArray];

  table.forEach((row, index) => {
    if (row.productId === productId && row.storeId === storeId
      && row.type === type
    ) {
      table.splice(index, 1);

    }
  })
  return table
}


export const updateTableCellHandlerSadan = (tableArray, productId, storeId, field, newValue, type) => {

  const table = [...tableArray];
  console.log(productId, storeId, field, newValue, type);

  //console.log(table[0].productId, table[0].storeId)

  table.forEach((row, index) => {

    if (row.productId === productId && +row.storeId === +storeId && row.type === type) {

      row[field] = newValue
      // table.splice(index, 1);
    }
  })
  return table

}
export const updateTableCellHandlerSadanByPack = (tableArray, productId, storeId, field, newValue, packId) => {

  const table = [...tableArray];

  table.forEach((row, index) => {

    if (row.productId === productId && row.storeId === storeId && row.packId === packId) {
      row[field] = newValue
      // table.splice(index, 1);
    }
  })
  return table

}
export const calculateSumOfTableData = (tableArray) => {


  if (tableArray) {

    const table = [...tableArray];
    return table.reduce((a, b) => a + +parseToEnRemoveComma(b.total), 0)
  }
  return 0
}

export const sumOfPaymentTable = (priceData) => {
  const table = [...priceData];
  return table.reduce((a, b) => a + +b.price, 0)
}

export const calculateTotalSum = (sendData, typeOfForm) => {

  const data = {...sendData}
  let totalSum = 0;
  let taxPrice = 0
  if (Object.keys(data).length > 0) {
    if (data.servicePrice === undefined) data.servicePrice = 0;
    if (data.totalDiscount === undefined) data.totalDiscount = 0;
    if (data.tax === undefined) data.tax = 0;

    const sumBeforeDiscount = calculateSumOfTableData(data.tableData) + +data.servicePrice;
    const sumAfterDiscount = sumBeforeDiscount - data.totalDiscount;
    totalSum = sumAfterDiscount * (1 + (data.tax / 100))
    taxPrice = totalSum - sumAfterDiscount
  }


  return {sum: Math.floor(totalSum), taxPrice};
}

export const isPaymentAndFactorSumEqual = (sendData) => {
  const data = {...sendData}

  const totalSum = calculateTotalSum(data).sum
  const totalPayments = sumOfPaymentTable(data.priceData)

  // const priceData1 = sumOfPaymentTable(priceData)
  // const sumOfAllFactor1 = calculateSumOfTableData(sumOfAllFactor)
  return totalSum === totalPayments
}

export const myCustomCelEditFunction = (sendData, setSendData, cell, field, newValue) => {
  const productId = cell.getData().productId;
  const storeId = cell.getData().storeId;
  const type = cell.getData().type;

  const tableData = updateTableCellHandlerSadan(sendData.tableData, productId, storeId, field, newValue, type);

  setSendData({tableData});

}
export const deleteExceptionKeysFromObject = (object) => {

  const myExceptionFields = object.exceptionFields;
  let newObject = {...object}
  for (const newObjectKey in newObject) {
    if (newObjectKey === 'exceptionFields') {
      delete newObject[newObjectKey]
    }

    if (myExceptionFields?.includes(newObjectKey)) {
      delete newObject[newObjectKey]
    }

  }


  return newObject
}

export const convertRestoreToStoreYESNO = (sendData) => {
  let temp = {...sendData}
  temp.tableData.forEach(row => {

    row.returnToStore = row.returnToStore === true ? "yes" : "no"
  })


  return temp
}
export const reverseConvertRestoreToStoreYESNO = (sendData) => {
  let temp = {...sendData}
  temp.tableData.forEach(row => {

    row.returnToStore = row.returnToStore === "yes"
  })


  return temp
}